import StorageService from './utils/storage-service';
import router from '@/router';

const storage = StorageService.getStorage();

if (!storage.isAvailable()) {
	router.push({ name: 'PrivacySettingsPage' });
}
const TOKEN_KEY = 'token';
const REFRESH_KEY = 'refresh_token';
const USER_KEY = 'user';
const ACCOUNT_KEY = 'account';

export default {
	token: storage.getItem(TOKEN_KEY) || undefined,
	refresh: storage.getItem(REFRESH_KEY) || undefined,
	user: storage.getItem(USER_KEY) || undefined,
	account: StorageService.getStorageValueWithFallback(storage, ACCOUNT_KEY, undefined),
	set({ user, token, refresh, account }) {
		// return this when we are stable with refresh tokens -- || !refresh
		if (!user || !token) return;
		try {
			storage.setItem(TOKEN_KEY, token);
			storage.setItem(REFRESH_KEY, refresh);
			storage.setItem(USER_KEY, user);
			StorageService.setStorageValueOrRemove(storage, ACCOUNT_KEY, account); //can be null

			this.token = token;
			this.refresh = refresh;
			this.user = user;
			this.account = account;
		} catch (e) {
			console.warn(e);
		}
	},
	setRefresh({ token, refresh }) {
		if (!token) return;
		try {
			storage.setItem(TOKEN_KEY, token);
			this.token = token;
			if (refresh) {
				storage.setItem(REFRESH_KEY, refresh);
				this.refresh = refresh;
			}
		} catch (e) {
			console.warn(e);
		}
	},
	get() {
		return {
			token: storage.getItem(TOKEN_KEY) || this.token,
			refresh: storage.getItem(REFRESH_KEY) || this.refresh,
			user: storage.getItem(USER_KEY) || this.user,
			account: StorageService.getStorageValueWithFallback(storage, ACCOUNT_KEY, null),
		};
	},
	clear() {
		try {
			storage.removeItem(TOKEN_KEY);
			storage.removeItem(REFRESH_KEY);
			storage.removeItem(USER_KEY);
			storage.removeItem(ACCOUNT_KEY);

			delete this.token;
			delete this.refresh;
			delete this.user;
			delete this.account;
		} catch (e) {
			//
		}
	},
};
